import * as yup from 'yup';

import { ConstraintMode } from '../../../_types';

const makeConstraintShape = () =>
  yup.object({
    min: yup
      .number()
      .required()
      .nullable()
      .min(0, 'Minimum value should be 0')

      .test((min, context) => {
        const max = context.resolve(yup.ref('max'));
        if (typeof min === 'number' && typeof max === 'number' && min > max) {
          return context.createError({ message: 'Min higher than max value' });
        }
        return true;
      }),
    max: yup
      .number()
      .min(0, 'Should be a non-negative value')
      .required()
      .nullable(),
  });

export const makeCpuAndMemoryConstraintsValidationSchema = () =>
  yup.object({
    cpu: makeConstraintShape(),
    memory: makeConstraintShape(),
  });

const makeConstraintV2Shape = (constantMin = 0) =>
  yup.object({
    mode: yup
      .string()
      .oneOf<ConstraintMode>(['constant', 'percentage'])
      .required(),
    min: yup
      .number()
      .required()
      .nullable()
      .when('mode', {
        is: 'constant',
        then: (s) =>
          s
            .min(constantMin, `Minimum value should be ${constantMin}`)
            .test((min, context) => {
              const max = context.resolve(yup.ref('max'));
              if (
                typeof min === 'number' &&
                typeof max === 'number' &&
                min > max
              ) {
                return context.createError({
                  message: 'Min higher than max value',
                });
              }
              return true;
            }),
        otherwise: (s) =>
          s.min(0, 'Should be a non-negative value').test((min, context) => {
            const max = context.resolve(yup.ref('max'));
            if (
              typeof min === 'number' &&
              typeof max === 'number' &&
              min > max
            ) {
              return context.createError({
                message: 'Min higher than max value',
              });
            }
            return true;
          }),
      }),
    max: yup
      .number()
      .min(0, 'Should be a non-negative value')
      .required()
      .nullable(),
  });

export const makeCpuAndMemoryConstraintsV2ValidationSchema = ({
  cpuMin,
  memoryMin,
}: {
  cpuMin?: number;
  memoryMin?: number;
} = {}) =>
  yup.object({
    cpu: makeConstraintV2Shape(cpuMin ?? 0),
    memory: makeConstraintV2Shape(memoryMin ?? 0),
  });
